import React from 'react'
import { Route } from 'react-router'
import { ChallengeShowPage } from '../ChallengeShowPage'
import { routes as adminRoutes } from '../admin/AdminApp'
import { ChallengeMap } from '../ChallengeMap'
import { SideNavLayout } from 'common/layouts/SideNavLayout'

export const routes = (
  <Route>
    <Route component={(props) => <SideNavLayout {...props} greyBg />}>
      <Route path=':challengeId' component={ChallengeShowPage} />
    </Route>
    {adminRoutes}
    <Route path=':challengeId/route_map' component={ChallengeMap} />
  </Route>
)
